var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriteUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3328 2.24731H3.44125C2.84326 2.24731 2.26976 2.48486 1.84692 2.90771C1.42407 3.33055 1.18652 3.90405 1.18652 4.50204V20.2851C1.18652 20.8831 1.42407 21.4566 1.84692 21.8794C2.26976 22.3023 2.84326 22.5398 3.44125 22.5398H19.2243C19.8223 22.5398 20.3958 22.3023 20.8186 21.8794C21.2415 21.4566 21.479 20.8831 21.479 20.2851V12.3936",
    stroke: "#9F9F9F",
    strokeWidth: 1.38343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5192 1.82448C18.9677 1.37598 19.576 1.12402 20.2103 1.12402C20.8446 1.12402 21.4528 1.37598 21.9013 1.82448C22.3498 2.27297 22.6018 2.88125 22.6018 3.51552C22.6018 4.14978 22.3498 4.75807 21.9013 5.20656L11.7404 15.3686C11.4727 15.6361 11.142 15.8318 10.7788 15.9379L7.53987 16.8849C7.44286 16.9132 7.34003 16.9149 7.24214 16.8898C7.14426 16.8647 7.05491 16.8138 6.98346 16.7424C6.912 16.6709 6.86107 16.5816 6.836 16.4837C6.81092 16.3858 6.81261 16.2829 6.84091 16.1859L7.78789 12.947C7.89446 12.5841 8.09063 12.2538 8.35834 11.9865L18.5192 1.82448Z",
    stroke: "#9F9F9F",
    strokeWidth: 1.38343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteUser);
export default __webpack_public_path__ + "static/media/write-user.9b10ef8594f8308e492d22f26dcd8699.svg";
export { ForwardRef as ReactComponent };